module.exports = __webpack_public_path__ + "b3e59cdd82264d5439673dca67017a66.png";